<template>
  <div class="d-flex justify-content-between flex-column">
    <div>
      <p class="text-primary text-small font-weight-bold mb-2">
        {{ trans("courses.word-hunter.step") }} {{ currentStep }}.
      </p>
      <h4 class="text-primary mt-0 mb-2" tabindex="0">
        {{ trans("courses.word-hunter.select_words_label") }}
      </h4>
      <p class="mb-3" v-html="trans('courses.word-hunter.select_words_desk')" />
    </div>
    <div class="mb-4" ref="target">
      <textarea
        @keydown="onEnter"
        ref="textarea"
        v-html="strippedText"
        class="w-100 border-light rounded-big p-4"
      />
      <div class="d-flex justify-content-end">
        <b-button
          class="mt-2"
          variant="outline-secondary"
          size="sm"
          @click="addCurrentWord"
          :disabled="!currentWord.length > 0 || selectedWords.length >= 3"
        >
          {{ trans("courses.word-hunter.mark_word") }}
        </b-button>
      </div>
    </div>
    <div>
      <p class="font-weight-bold" id="selectWord">
        {{ trans("courses.word-hunter.select_words") }}
      </p>
      <div class="row mt-3">
        <div class="col-12 d-flex flex-column words-wrapper">
          <div class="row words-placeholder" aria-hidden="true">
            <div class="col-md-12">
              <div class="mt-1 mb-4 font-weight-bold">1.</div>
              <div class="mt-1 mb-4 font-weight-bold">2.</div>
              <div class="mt-1 mb-4 font-weight-bold">3.</div>
            </div>
          </div>
          <b-button-group
            aria-labelledby="selectWord"
            class="mb-1 ml-4"
            v-for="(keyword, key) in selectedWords"
            :key="key"
            pill
          >
            <button class="word-badge" tabindex="0" @click="$emit('unSelectWord', key)">
              {{ keyword.word }}
              <div class="icon">
                <b-icon-x scale="1.3" :aria-label="trans('courses.word-hunter.remove_selection')" />
              </div>
            </button>
          </b-button-group>
        </div>
        <div class="col-12 mt-3">
          <div class="d-flex justify-content-end w-100">
            <b-button @click="onClickNext" :disabled="!enableNextButton">{{
              trans("courses.word-hunter.next")
            }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WordSelector",
  props: {
    textContent: String,
    selectedWords: Array,
    currentStep: Number,
    trackingData: Object,
  },
  data() {
    return {
      currentWord: "",
    };
  },
  methods: {
    onClickNext() {
      trackEvent("WordhunterStep1", this.trackingData);
      this.$emit("next");
    },
    addCurrentWord() {
      this.$emit("selectWord", this.currentWord);
      this.currentWord = "";
    },
    selectWord(selection) {
      this.currentWord = selection;
    },
    listenForSelectedWord(event) {
      const selection = event.target.value.substring(
        event.target.selectionStart,
        event.target.selectionEnd
      );
      if (event.srcElement === this.$refs.textarea) {
        this.selectWord(selection);
      }
    },
    onEnter: function (e) {
      const code = e.code;
      if (
        code !== "ArrowLeft" &&
        code !== "ArrowRight" &&
        code !== "ArrowUp" &&
        code !== "ArrowDown" &&
        code !== "Tab"
      ) {
        e.stopPropagation();
        e.preventDefault();
        e.returnValue = false;
      }
    },
  },
  mounted() {
    this.$refs.textarea.onselect = this.listenForSelectedWord;
  },
  computed: {
    strippedText() {
      return this.textContent.replace(/<[^>]*>?/gm, "");
    },
    enableNextButton() {
      return this.selectedWords.length >= 1 && this.selectedWords.length <= 3;
    },
  },
};
</script>

<style scoped lang="scss">
textarea {
  background-color: transparent;
  height: 80%;
}
.word-badge {
  background-color: $color-light;
  border-radius: 2rem;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  padding: 0.29rem 2.5rem 0.21rem 1rem;
  position: relative;
  margin: 0px 0 11px 0;
  border: none;

  .icon {
    position: absolute;
    right: 1rem;
    top: 0.4rem;
    cursor: pointer;
  }
}
.words-wrapper {
  position: relative;
  height: 150px;

  .words-placeholder {
    position: absolute;
  }
}
</style>
